module.exports = __webpack_public_path__ + "img/arrow_back_grey.d6ac974f.svg";